export enum Modes {
  EAGER = 'EAGER',
  ALL = 'ALL',
  ONE = 'ONE',
}
